export default __webpack_public_path__ + "static/media/james.ba63c18e.jpeg";